import { unauthedRequest } from "./requests";

/**
 *
 * /registrations resource requests
 *
 * `postRegistration` (POST v2/registrations) was removed with the in-app
 * sign-up flow — this client no longer creates accounts, it forwards new
 * customers to the marketing product page. Email confirmation is unaffected
 * and still runs through `verifyRegistration` below.
 *
 */
export const verifyRegistration = ({ payload }) =>
 unauthedRequest(`v2/confirmations?confirmation_token=${payload}`, {}).then(r => r);


